import { mapActions, mapState } from "vuex";

export default {
	computed: {
		...mapState("shop", {
		  catalog: (state) => state.index,
		  card: (state) => state.card,
		}),
		cat() {
			return this.catalog[this.category];
		  },
	  },
	  methods: {
		...mapActions("shop", {
		  actionIndex: "index",
		  changeAmount: "changeAmount",
		}),
		openModal(item) {
		  this.modalItem = item;
		},
		showItem(item, category) {
		  this.$router.push({
			name: "ShopItem",
			params: {
			  category: category,
			  product: item.product_id,
			},
		  });
		},
	  },	
}